export default __webpack_public_path__ + "static/media/google--white.1016a5eb.svg";